export default {
      id: "ic_profil-usage",
      viewBox: "0 0 35 35",
      url: "../dist/images/" + "sprite.svg#ic_profil-usage",
      toString: function () {
        return this.url;
      }
    }